import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IAppDB } from '@/shared/lib/db';

import { UIError } from '@/shared/utils/ui-error';

export type UseCaseInput = {
  id: string;
};
export type UseCaseOutput = void;

export class RemoveItemUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private db: IAppDB;

  constructor(db: IAppDB) {
    this.db = db;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { id } = input;

    const item = await this.db.items.get(id);

    if (!item) throw new UIError('ITEM_NOT_FOUND', 'Item não encontrado.');

    await this.db.items.delete(id);

    return void 0;
  }
}
